<template>
    <div class="form-group">
      <div :class="hasIcon(icon)">
        <span v-if="iconDir === 'left'" class="input-group-text">
          <i :class="getIcon(icon)"></i>
        </span>
        <select
          :type="type"
          class="w-100 border-0 "
          :class="getClasses(size, valid)"
          :name="name"
          :id="id"
          :value="modelValue"
          :placeholder="placeholder"
          :isRequired="isRequired"
          @input="onInput"
          :disabled="read"
        >
        <option v-for="choice in choices" :value="choice.value" :key="choice.value">{{ choice.text }}</option>
        </select>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "argon-select",
    props: {
      size: {
        type: String,
        default: "default",
      },
      valid: {
        type: Boolean,
        default: false,
      },
      icon: String,
      iconDir: String,
      name: String,
      id: String,
      value: String,
      modelValue: {
        type: String,
        default: "",
      },
      choices:{
        type:Array,
        // default:[{value:'No data',text:'No data'}]
      },
      placeholder: String,
      type: String,
      isRequired: Boolean,
      read:{
        type:Boolean,
        default:false
      }
    },
    emits:["update:modelValue"],
    methods: {
      getClasses: (size, valid) => {
        let sizeValue, isValidValue;
  
        sizeValue = size ? `form-control-${size}` : null;
  
        isValidValue = valid ? `${valid}` : "invalid";
  
        return `${sizeValue} ${isValidValue}`;
      },
      getIcon: (icon) => (icon ? icon : null),
      hasIcon: (icon) => (icon ? "input-group" : null),
      onInput(e){
        this.$emit("update:modelValue",e.target.value)
      },
    },
  };
  </script>